<div class="statistics-distribution-bar">
    <div class="visits-percentage">
        ({{ ((visits / totalVisits) * 100 || 0) | monNumber:'0.[00]'}} %)
    </div>
    <div class="progress-xxs progress-square mb-2">
        <ngb-progressbar class="mr-2" [value]="((visits / totalVisits) * 100 || 0)"></ngb-progressbar>
    </div>
</div>
